export default "__VITE_ASSET__CsQB$hpE__"